import React, { createContext, useContext, useMemo, useState } from "react";

const MASKED_BALANCE_VALUE = "******";

const DashboardBalanceVisibilityContext = createContext({
  showBalances: false,
  toggleBalances: () => {},
  formatCurrencyValue: (value, currencySymbol = "", formatter) => {
    if (formatter) {
      return `${currencySymbol || ""}${formatter(value)}`;
    }

    return `${currencySymbol || ""}${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  },
});

export const DashboardBalanceVisibilityProvider = ({ children }) => {
  const [showBalances, setShowBalances] = useState(false);

  const toggleBalances = () => {
    setShowBalances((prev) => !prev);
  };

  const value = useMemo(
    () => ({
      showBalances,
      toggleBalances,
      formatCurrencyValue: (amount, currencySymbol = "", formatter) => {
        if (!showBalances) {
          return `${currencySymbol || ""}${MASKED_BALANCE_VALUE}`;
        }

        if (formatter) {
          return `${currencySymbol || ""}${formatter(amount)}`;
        }

        return `${currencySymbol || ""}${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      },
    }),
    [showBalances]
  );

  return <DashboardBalanceVisibilityContext.Provider value={value}>{children}</DashboardBalanceVisibilityContext.Provider>;
};

export const useDashboardBalanceVisibility = () => useContext(DashboardBalanceVisibilityContext);
